exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-contact__intro{margin-bottom:30px}.page-contact__select-question{margin:1em 0 .6em;line-height:1.6em}.page-contact__form-title{text-align:left;margin-bottom:.4em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75a2c96a","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-contact.vue
// module id = 67
// module chunks = 0